<template>
  <section class="bg-white px-5 pb-4 md:py-5 md:rounded">
    <div class="title-section" :class="twMerge('py-4', props.titleSectionClass)">
      <div class="flex justify-between items-center gap-1">
        <h2 v-if="title" class="title font-500 text-lg md:text-xl">{{ title }}</h2>
        <slot v-else name="title" />
        <slot name="title-action" />
      </div>
      <p v-if="subtitle" class="mt-1 text-gray-80 text-sm">{{ subtitle }}</p>
    </div>
    <slot />
    <product-view-all-button v-if="props.isViewAllShown" @view-all-click="$emit('view-all-click')" />
  </section>
</template>

<script lang="ts" setup>
import { twMerge } from 'tailwind-merge'

import ProductViewAllButton from '@/components/product/product-detail/product-view-all-button.vue'

interface Props {
  title?: string
  subtitle?: string
  titleSectionClass?: string
  isViewAllShown?: boolean
}

interface Emits {
  (event: 'view-all-click'): void
}

const props = withDefaults(defineProps<Props>(), { isViewAllShown: false })

defineEmits<Emits>()
</script>
